import setLanguageContent from 'helpers/setLanguageContent';
import combineStyles from 'components/Templates/general/combineStyles';
import cloneDeep from 'helpers/cloneDeep';
import injectComponent from 'helpers/injectComponent';


export async function fnSetStyling(getSectionData, thisSectionSelect, customStyles) {

  try {

    if (!getSectionData || !thisSectionSelect) return null;

    const awaitRequire = await injectComponent(getSectionData.type, thisSectionSelect.componentName, 'style');

    if (!awaitRequire || !awaitRequire.default) return;

    let requireStyling = cloneDeep(awaitRequire.default);

    async function customStylesSelect()  {
      try {
        const awaitCustom = await injectComponent(getSectionData.type, getSectionData.componentName, 'default');
        if (!awaitCustom || !awaitCustom.default) return customStyles;
        return {
          ...awaitCustom.default,
          ...customStyles
        };
      } catch(error) {
        console.log(error);
      }
    };

    const getCustomStyles = await customStylesSelect();

    requireStyling = combineStyles(requireStyling, getSectionData.styling, getCustomStyles);

    return requireStyling;
  } catch(e) {
    console.log(e);
  }

}

export function selectCurrentPage(thisEventData, slug) {

  if (!thisEventData || thisEventData && !thisEventData.template.templateSchema || thisEventData && thisEventData.template.templateSchema && !thisEventData.template.templateSchema.pages) return '';

  const {
    pages
  } = thisEventData.template.templateSchema;

  let currentPage;
  let homePage;

  const thisSlug = slug ? slug : thisEventData.pageSlug;


  for (let i = 0; i < pages.length; i++) {

    if (!pages[i].slug) continue;

    if (pages[i].slug === '/' || !thisSlug && pages[i].slug === '/') {
      homePage = pages[i];
    }

    if (!thisSlug && pages[i].slug === '/' || pages[i].slug === thisSlug) {
      currentPage = pages[i];
      break;
    }
  }
  
  return currentPage ? currentPage : '';
}





export function setSectionsContent(props, templateSchema, currentPage) {

  if (!templateSchema || !currentPage) return;

  const {
    params      
  } = props;

  const {
    chapterSlug,
    pageSlug,
    secondSlug
  } = params;

  let thisPage = templateSchema.pages.filter((page) => {
    return page.pageId === currentPage;
  });
  if (thisPage && thisPage[0]) thisPage = thisPage[0];

  if (!thisPage) return;

  const {
    pages,
    speakers,
  } = templateSchema;


  if (!pages) return;

  const {
    sections
  } = thisPage;

  if (!sections) return;


  const isHome = thisPage.slug === '/' || !thisPage.slug;

  const getPageTitle = setLanguageContent(thisPage, thisPage.metaTitle || isHome ? 'metaTitle' : 'title');
  const metaTitle = setLanguageContent(templateSchema, 'metaTitle');

  
  let isSpeaker = '';

  if (chapterSlug === 'speaker' || pageSlug === 'speaker' || secondSlug === 'speaker') {

    for (let index = 0; index < speakers.length; index++) {
      const element = speakers[index];

      if (element.slug === secondSlug || element.slug === pageSlug || element.slug === chapterSlug) {
        isSpeaker = `${element.firstName ? element.firstName : ''} ${element.lastName ? element.lastName : ''} | `;
      }
    }
  }


  const metaTitleState = isSpeaker + `${getPageTitle && !isHome ? getPageTitle+' | ' : '' }` + `${metaTitle ? metaTitle : setLanguageContent(templateSchema, 'title')}`;

  return {
    title: metaTitleState,
    description: thisPage.metaDescription ? thisPage.metaDescription : templateSchema.metaDescription,
    currentPage: thisPage.pageId,
    pageSlug: thisPage.slug && thisPage.slug[0] === '/' ? thisPage.slug : thisPage.slug ? '/'+thisPage.slug : '',
    sections: sections.filter((section) => {
      const thisSectionData = section;
      if (!thisSectionData || thisSectionData && thisSectionData.isSectionHidden) return false;
      return true;
    })
  };

};